import React from 'react';
import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import InsuranceDocumentBlock from '../../RequirementBlocks/InsuranceDocumentBlock';

import RequirementBlock from './RequirementBlock';

const RequiredDocumentsBlock = ({ documentRequirements }) => (
  <RequirementBlock title="Required Documents">
    {documentRequirements.length < 1
      ? <Text fontStyle="italics">None</Text>
      : documentRequirements.map(docReq => (
        <div key={docReq.id}>
          <InsuranceDocumentBlock
            description={docReq.insuranceDocumentTypeDescription}
            displayName={docReq.insuranceDocumentTypeDisplayName}
            isRequired={docReq.required}
          />
        </div>
      ))}
  </RequirementBlock>
);

RequiredDocumentsBlock.propTypes = {
  documentRequirements: PropTypes.arrayOf(PropTypes.shape({
    insuranceDocumentTypeDescription: PropTypes.string,
    insuranceDocumentTypeDisplayName: PropTypes.string,
    required: PropTypes.bool
  }))
};

export default RequiredDocumentsBlock;
